import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const useCircleValidationSchema = () => {
	const { t } = useTranslation()

	const circleSchema = yup.object({
		radius: yup
			.string()
			.matches(/^[0-9]*$/, t('Only numbers'))
			.required(t('This field is required'))
	})

	return yupResolver(circleSchema)
}
